// File: `app/javascript/controllers/product_module/buggy.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initBuggy(deps = {}) {
    const {
        form_type_send,
        excursion_lang,
        create_array_for_product,
        service_by_dealer,
        get_contract,
        modality_info,
        create_id_for_product,
        setSessionVar,
        showDescriptionModal,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    // Selectores
    const buggy_to = $('#buggy_to');
    const buggy_date = $('#buggy_date');
    const buggy_type = $('#buggy_type');
    const buggy_modality = $('#buggy_modality');
    const buggy_pax_block = $('#buggy_pax_block');
    const buggy_pax = $('#buggy_pax');
    const buggy_cantidad_block = $('#buggy_cantidad_block');
    const buggy_cantidad = $('#buggy_cantidad');
    const buggy_adult_childrens = $('#buggy_adult_childrens');
    const buggy_adultos = $('#buggy_adultos');
    const buggy_childrens = $('#buggy_childrens');
    const buggy_btn_info = $('#buggy_btn_info');
    let buggy_btn_info_desc = '';

    // Inicializaciones UI
    buggy_date.prop('disabled', true);
    buggy_type.prop('disabled', true).select2({ theme: 'bootstrap' });
    buggy_modality.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_modality')
    });
    buggy_pax.prop('disabled', true).select2({ theme: 'bootstrap' });

    // Select2 para destino y reacción al cambio
    buggy_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: '/destination',
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                const result = (data.rows || []).map(elem => ({
                    id: `${elem.code}|${elem.id}|${elem.name}`,
                    text: elem.name
                }));
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        const parts = (e.target.value || '').split("|");
        const destinationId = parts[1];
        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', destinationId);
        create_array_for_product('destination_code', parts[0]);
        create_array_for_product('text_destination', parts[2]);

        // Limpieza UI/estado
        buggy_type.empty();
        buggy_modality.empty();
        buggy_pax.empty();
        buggy_date.val('');
        $('#excursion_location').val('');
        if (excursion_lang) excursion_lang.empty();
        if (buggy_btn_info[0]) {
            buggy_btn_info[0].classList.add('ocultar');
        }
        buggy_btn_info_desc = '';

        // Obtener servicios del dealer y construir opciones internas
        // FIX (2026-08-10): bloquear el formulario mientras service_by_dealer carga.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            service_by_dealer(destinationId, form_type_send),
            { timeout: 30000 }
        ).then(sbd => {
            const result = (sbd.services || []).map(elem => ({
                id: [
                    elem.id,
                    elem.code,
                    elem.reservation_time,
                    sbd.dealer_code,
                    sbd.dealer_name,
                    sbd.dealer_id,
                    elem.min_reservation_amount,
                    elem.max_reservation_amount
                ].join('|'),
                text: elem.name
            }));

            // UI ajustes
            buggy_modality.empty();
            if (buggy_pax_block[0]) buggy_pax_block[0].classList.remove('ocultar');
            if (buggy_cantidad_block[0]) buggy_cantidad_block[0].classList.add('ocultar');
            if (buggy_adult_childrens[0]) buggy_adult_childrens[0].classList.add('ocultar');
            if (buggy_btn_info[0]) buggy_btn_info[0].classList.add('ocultar');

            if (!result.length) return;

            const product_type = result[0].id.split("|");
            const product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            if ($('#excursion_lang_container')[0]) {
                $('#excursion_lang_container')[0].classList.remove('ocultar');
            }
            if (excursion_lang && excursion_lang[0]) excursion_lang[0].classList.add('required');

            // Guardar datos del producto en el carrito/estado
            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // Traer contrato si es necesario (con bloqueo + desbloqueo garantizado)
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            // Activar fecha y configurar selección de modalidades
            buggy_date.prop('disabled', false);

            let modality_selected = '';

            buggy_modality.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_modality'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            product: product_type[0],
                            dealer: product_type[5]
                        };
                    },
                    type: 'GET',
                    processResults: function (data) {
                        const rows = data.rows || [];
                        return { results: rows.map(r => ({ id: r, text: r })) };
                    }
                }
            }).on('change', function (e) {
                modality_selected = e.target.value;
                create_array_for_product('modalities_name', e.target.value);
                buggy_btn_info[0].classList.add('ocultar');
                buggy_btn_info_desc = '';

                if (product_name.includes('bicicleta')) {
                    // comportamiento para bicicletas
                    buggy_pax_block[0].classList.add('ocultar');
                    buggy_adult_childrens[0].classList.add('ocultar');
                    buggy_cantidad_block[0].classList.remove('ocultar');

                    buggy_cantidad[0].setAttribute('data-min', product_type[6]);
                    buggy_cantidad[0].setAttribute('data-max', product_type[7]);
                    create_array_for_product('day_min_rent', product_type[6]);
                    create_array_for_product('day_max_rent', product_type[7]);
                    buggy_cantidad.val(1).trigger('change');
                } else {
                    withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                        modality_info(product_type[5], product_type[0], modality_selected),
                        { timeout: 30000 }
                    ).then(modality => {
                        create_array_for_product('calc_amount', modality.calc_amount);
                        if (modality.info === 'true') {
                            if (modality.has_pax) {
                                buggy_pax_block[0].classList.add('ocultar');
                                buggy_cantidad_block[0].classList.add('ocultar');
                                buggy_adult_childrens[0].classList.remove('ocultar');

                                buggy_adultos[0].setAttribute('data-min', modality.min);
                                let min = (parseInt(modality.min) - 1) <= 0 ? 0 : 1;
                                buggy_childrens[0].setAttribute('data-min', min);
                                buggy_adultos[0].setAttribute('data-max', modality.max);
                                buggy_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1));
                                buggy_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                buggy_childrens[0].setAttribute('data-evaluate-max', modality.max);

                                create_array_for_product('day_min_rent', min);
                                create_array_for_product('day_max_rent', modality.max);
                            } else {
                                buggy_pax_block[0].classList.remove('ocultar');
                                buggy_cantidad_block[0].classList.add('ocultar');
                                buggy_adult_childrens[0].classList.add('ocultar');
                                buggy_pax.prop('disabled', false);
                            }
                        }
                    });
                }
            });

            // Handlers para adultos / niños / cantidad / pax
            buggy_adultos.on('change', function (e) {
                if (buggy_btn_info[0]) buggy_btn_info[0].classList.add('ocultar');
                let valueChild = buggy_childrens.val();
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected, false, e.target.value, valueChild),
                    { timeout: 30000 }
                ).then(modality => {
                    const dataset = e.target.dataset;
                    const helper = $(`#${dataset.helper}`);
                    if (modality.data === null) {
                        if (helper.length) helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`;
                    } else {
                        if (helper.length) {
                            helper[0].innerHTML = '';
                            e.target.classList.remove('is-invalid');
                            buggy_childrens[0].classList.remove('is-invalid');
                        }
                        create_array_for_product('modality_code', modality.data.code);
                        if (modality.description) {
                            buggy_btn_info[0].classList.remove('ocultar');
                            buggy_btn_info_desc = modality.description;
                        }
                        create_array_for_product('pax', dataset.evaluateMax);
                        create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax);
                    }
                });
            });

            buggy_childrens.on('change', function (e) {
                if (buggy_btn_info[0]) buggy_btn_info[0].classList.add('ocultar');
                let adultVal = buggy_adultos.val();
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected, false, adultVal, e.target.value),
                    { timeout: 30000 }
                ).then(modality => {
                    const dataset = e.target.dataset;
                    const helper = $(`#${dataset.helper}`);
                    if (modality.data === null) {
                        if (helper.length) helper[0].innerHTML = `<span class='text-danger'>Esta experiencia solo admite reservas para ${dataset.evaluateMax} PAX</span>`;
                    } else {
                        if (helper.length) {
                            helper[0].innerHTML = '';
                            e.target.classList.remove('is-invalid');
                            buggy_adultos[0].classList.remove('is-invalid');
                        }
                        create_array_for_product('modality_code', modality.data.code);
                        if (modality.description) {
                            buggy_btn_info[0].classList.remove('ocultar');
                            buggy_btn_info_desc = modality.description;
                        }
                        create_array_for_product('pax', dataset.evaluateMax);
                        create_id_for_product(product_type[0], product_type[3], product_type[1], modality.data.code, dataset.evaluateMax);
                    }
                });
            });

            buggy_cantidad.on('change', function (e) {
                if (buggy_btn_info[0]) buggy_btn_info[0].classList.add('ocultar');
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected),
                    { timeout: 30000 }
                ).then(modality_by_cant => {
                    const code = modality_by_cant.data && modality_by_cant.data[0] && modality_by_cant.data[0].code;
                    if (code) {
                        create_array_for_product('modality_code', code);
                        if (modality_by_cant.description) {
                            buggy_btn_info[0].classList.remove('ocultar');
                            buggy_btn_info_desc = modality_by_cant.description;
                        }
                        create_array_for_product('pax', e.target.value);
                        create_array_for_product('amount', e.target.value);
                        create_id_for_product(product_type[0], product_type[3], product_type[1], code, e.target.value);
                    }
                });
            });

            buggy_pax.select2({
                theme: "bootstrap",
                ajax: {
                    url: '/modalities/pax',
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            page: params.page || 1,
                            product: product_type[0],
                            dealer: product_type[5],
                            modality: modality_selected
                        };
                    },
                    type: 'GET',
                    processResults: function (data, params) {
                        const rows = data.rows || [];
                        const result = rows.map(elem => ({
                            id: `${elem.id}|${elem.code}|${elem.max_reservation_amount}`,
                            text: elem.name
                        }));
                        const total = data.total || 0;
                        return {
                            results: result,
                            pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                        };
                    }
                }
            }).on('change', function (e) {
                const modality_type = (e.target.value || '').split("|");
                create_array_for_product('modality_code', modality_type[1]);
                create_array_for_product('pax', modality_type[2]);
                create_id_for_product(product_type[0], product_type[3], product_type[1], modality_type[1], modality_type[2]);
                if (buggy_btn_info[0]) buggy_btn_info[0].classList.add('ocultar');
            });

            // Fecha con flatpickr
            flatpickr(buggy_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            buggy_date.on('change', function (e) {
                setSessionVar('from_date', e.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });

            buggy_btn_info.on('click', function () {
                showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, buggy_btn_info_desc);
            });
        });
    });
}
